import { render, staticRenderFns } from "./SubjectData.vue?vue&type=template&id=a7ebcbd0&scoped=true&"
import script from "./SubjectData.vue?vue&type=script&lang=js&"
export * from "./SubjectData.vue?vue&type=script&lang=js&"
import style0 from "./SubjectData.vue?vue&type=style&index=0&id=a7ebcbd0&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ebcbd0",
  null
  
)

export default component.exports